module.exports = __webpack_public_path__ + "static/media/sequelize.d3ee3787.png";